export default "__VITE_ASSET__B0O2Fbj5__"